import React from 'react';
function OtherStyles({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M4 6C4 4.89543 4.89543 4 6 4H16C17.1046 4 18 4.89543 18 6V16C18 17.1046 17.1046 18 16 18H6C4.89543 18 4 17.1046 4 16V6Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 9V18C21 19.6569 19.6569 21 18 21H9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="2 2"
      />
    </svg>
  );
}

export default OtherStyles;
